/* eslint-disable arrow-spacing */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import 'moment/min/locales';
import { FormattedMessage } from 'react-intl';

import moment from 'utils/moment';
import Collapsible from '../../../../components/collapsible/Collapsible';
import Clickable from '../../../../components/clickable/Clickable';
import PhotoCarousel from '../../../../components/photoCarousel/PhotoCarousel';
import Modal from '../../../../components/modal';
import Map from '../../components/Map';
import PictureDraggable from '../../../sms/components/PictureDraggable';
import Loading from '../../../../components/loading/loading';
import { renderInfoForType } from '../../../../utils/helpers';
import styles from './workOrderDetail.module.scss';
import CustomFieldDetail from '../../../../components/customFields/CustomFieldDetail';

class WorkorderInfo extends Component {
  state = {
    modal: false,
    loadingStatus: false,
    terminalModal: false
  };

  componentDidMount() {
    this.setState({ loadingStatus: true });
}

  componentDidUpdate() {
    const { workorder } = this.props;
    const { loadingStatus }= this.state;
    if (workorder.id && loadingStatus) {
      this.setState({ loadingStatus: false });
    }
  }

  openPhotoModal = (idx) => {
    this.setState({ modal: true, initialSlide: idx });
  }

  handleDisplay = () => {
    const { terminalModal } = this.state;
    this.setState({ terminalModal: !terminalModal });
  };

  handleFieldTitles = (field) => {
    const { workorder } = this.props;
    let title = workorder?.answer_schema?.default_fields?.[field]?.title;
    return title;
  }

  getFieldTitle = (key, fallback) => this.handleFieldTitles(key) || fallback

  render() {
    const { workorder, translation, workOrderFields, handleWildlifeSpeciesField, user } = this.props;
    const { modal, initialSlide, loadingStatus, terminalModal } = this.state;

    const maintenanceDetails = user?.portal_airport?.airport_settings?.public_nawo_nomenclature?.length > 0
      ? user?.portal_airport?.airport_settings?.public_nawo_nomenclature : 'Work Order Request';

    let location = workorder?.airfield_location?.coordinates;
    if (workorder?.global_locations?.location && workorder?.global_locations?.selected_map === 'airfield') {
      location = workorder?.global_locations?.location;
    }

    let location_marked = workorder?.location_marked;
    if (workorder?.global_locations?.location_marked) {
      location_marked = workorder?.global_locations?.location_marked;
    }
    return (
      <>
    {loadingStatus && <Loading loadingStatus={loadingStatus} />}
      <Collapsible
        title="workorder.detail.request_header"
        defaultMessage={maintenanceDetails}
        translationValues={{ maintenanceDetails }}
        styleClasses={styles.collapsibleHeader}
        offset={400}
        openOnMount
      >
        <div className={styles.sectionHeader}>
          <FormattedMessage id="workorder.detail.request.request_title" defaultMessage="Work details" />
        </div>
        <div className={styles.requestInfo}>
          <div className={styles.infoTable}>
            <div className={styles.infoRow}>
              <span className={styles.title}>
                  <FormattedMessage
                      id={this.getFieldTitle('default_logged_by', 'workorder.detail.requested_by')}
                      defaultMessage={this.getFieldTitle('default_logged_by', 'Requested by')}
                    />
              </span>
              <span className={styles.rowContent}>
                {workorder?.logged_by ? (workorder?.logged_by?.fullname) : (
                   (workorder?.public_info && workorder?.public_info?.name && workorder?.public_info?.last_name
                   && `${workorder?.public_info?.name} ${workorder?.public_info?.last_name}`)
                    || (workorder?.public_info?.name)
                    || (workorder?.public_info?.last_name)
                    || ('Public'))}
              </span>
            </div>
            <div className={styles.infoRow}>
              <span className={styles.title}>
                <FormattedMessage
                  id={this.getFieldTitle('default_reported_date', 'workorder.detail.request.report_date')}
                  defaultMessage={this.handleFieldTitles('default_reported_date', 'Report date')}
                />
              </span>
              <span className={styles.rowContent}>
                {moment(workorder.report_date).format('MM/DD/YYYY hh:mm A')}
              </span>
            </div>
            <div className={styles.infoRow}>
              <span className={styles.title}>
                <FormattedMessage
                  id={this.getFieldTitle('default_priority', 'workorder.detail.request.priority')}
                  defaultMessage={this.handleFieldTitles('default_priority', 'Priority')}
                />
              </span>
              <span className={styles.rowContent}>
                {workorder.priority}
              </span>
            </div>
            <div className={styles.infoRow}>
              <span className={styles.title}>
                <FormattedMessage
                  id={this.getFieldTitle('default_category', 'workorder.detail.request.category')}
                  defaultMessage={this.handleFieldTitles('default_category', 'Category')}
                />
              </span>
              <span className={styles.rowContent}>
                {workorder.category}
              </span>
            </div>
            {workorder?.other_category_description && workorder?.other_category_description !== null && (
              <div className={styles.infoRow}>
                <span className={styles.title}>
                  <FormattedMessage
                    id="workorder.create.other"
                    defaultMessage="OtherCategory Input"
                  />
                </span>
                <span className={styles.rowContent}>{workorder?.other_category_description}</span>
              </div>
              )}
            <div className={styles.infoRow}>
                <span className={styles.title}>
                  <FormattedMessage id="tenants.new.name" defaultMessage="Company Name" />
                </span>
                <span className={styles.rowContent}>
                  {workorder.tenant_id}
                </span>
            </div>
            <div className={styles.infoRow}>
              <span className={styles.title}>
                <FormattedMessage
                  id={this.getFieldTitle('default_location', 'lease.maintenance.settings.location')}
                  defaultMessage={this.handleFieldTitles('default_location', 'Location')}
                />
              </span>
              <span className={styles.rowContent}>
                {workorder.location}
                {location_marked
                && Object.keys(location_marked).length > 0 && (
                  <div>
                    <Clickable
                      onClick={this.handleDisplay}
                      className={styles.terminalLink}
                    >
                      <FormattedMessage
                        id="maintenance.custom_location.click_notation_detail"
                        defaultMessage="Click here to view location on map"
                      />
                    </Clickable>
                  </div>
                )}
              </span>
            </div>
            {workorder?.other_location_desc && workorder?.other_location_desc !== null && (
              <div className={styles.infoRow}>
                <span className={styles.title}>
                  <FormattedMessage
                    id="workorder.detail.request.otherLocation"
                    defaultMessage="OtherLocation Input"
                  />
                </span>
                <span className={styles.rowContent}>{workorder?.other_location_desc}</span>
              </div>
            )}
            {workorder.sub_location && (
              <div className={styles.infoRow}>
                <span className={styles.title}>
                  <FormattedMessage
                    id="lease.maintenance.settings.sub_location"
                    defaultMessage="Sub-Location"
                  />
                </span>
                <span className={styles.rowContent}>
                  {workorder.sub_location}
                </span>
              </div>
            )}
            {workorder?.global_locations?.global_location?.location2 && (
              <div className={styles.infoRow}>
                <span className={styles.title}>
                  <FormattedMessage
                    id="lease.maintenance.settings.location2"
                    defaultMessage="Location - Level2"
                  />
                </span>
                <span className={styles.rowContent}>
                  {workorder?.global_locations?.global_location?.location2}
                </span>
              </div>
            )}
            {workorder?.global_locations?.global_location?.location3 && (
              <div className={styles.infoRow}>
                <span className={styles.title}>
                  <FormattedMessage
                    id="lease.maintenance.settings.location3"
                    defaultMessage="Location - Level3"
                  />
                </span>
                <span className={styles.rowContent}>
                  {workorder?.global_locations?.global_location?.location3}
                </span>
              </div>
            )}
            {location?.length > 0 && (
              <>
                <div className={styles.requestInfoField}>
                  <span className={styles.title}>
                    <FormattedMessage
                      id="lease.maintenance.location.indoor_map"
                      defaultMessage="Airfield Location"
                    />
                  </span>
                </div>
                <div style={{ height: '350px' }}>
                  <Map
                    defaultLocation={location}
                  />
                </div>
              </>
            )}
            {location_marked
              && workorder.location_attachment
              && workorder.location_attachment.length > 0 && (
                <div className={styles.locationTitle}>
                  <PictureDraggable
                    attachment={workorder.location_attachment[0]}
                    display={terminalModal}
                    handleDisplay={this.handleDisplay}
                    detail
                    position={location_marked}
                    location={workorder.location}
                    maintenenceDetails
                  />
                </div>
              )}
          </div>
        </div>
        <div className={styles.requestInfoField}>
          <span className={styles.title}>
            <FormattedMessage
              id={this.getFieldTitle('default_description', 'workorder.detail.request.problem_description')}
              defaultMessage={this.handleFieldTitles('default_description', 'Problem description')}
            />
          </span>
          <div className={styles.content}>
            {workorder.problem_description}
          </div>
        </div>
        {Object.keys(workorder.attachments).length > 0 && (
          <div className={styles.requestInfoField}>
            <span className={styles.title}>
              <FormattedMessage
                  id={this.getFieldTitle('default_photos', 'workorder.detail.request.photos')}
                  defaultMessage={this.handleFieldTitles('default_photos', 'Photos')}
                />
            </span>
            { Object.keys(workorder.attachments).length > 1 ? (
              <div className={styles.photos}>
                {workorder.attachments.map((e, idx) => (
                  <Clickable
                    key={e.id}
                    onClick={() => this.openPhotoModal(idx)}
                  >
                   <img src={e.url} alt={e.id} className={styles.image} />
                  </Clickable>
                ))}
              </div>
            )
              :(
                <div className={styles.photo}>
                  {workorder.attachments.map((e, idx) => (
                    <Clickable
                      key={e.id}
                      onClick={() => this.openPhotoModal(idx)}
                    >
                      <img src={e.url} alt={e.id} className={styles.image} />
                    </Clickable>
                  ))}
                </div>
              )}
          </div>
        )}
        <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
          {workorder.answer_schema.fields.map(f => (
            <>
              {f.dataSourceID !== 'ds10' && !f.type.includes('multi_field') && !f.type.includes('user_dropdown')
              && !f.type.includes('dataSourceMultiLevel')
            &&(
            <div key={f.id} className={f.widget && f.widget.type === 'textfield' ? styles.infoFull : styles.infoHalf}>
              <span>{translation && translation[f.title] ? translation[f.title] : f.title}</span>
              <p>{renderInfoForType(f, workorder.response[f.id], workorder)}</p>
            </div>
            )}
              {f.type.includes('multi_field')
              &&(
              <div key={f.id} style={{ width: '100%', padding: '0px', fontSize: '15px' }}>
                  <>
                    {workOrderFields && Object.keys(workOrderFields).length>0
                    && workorder && workorder.answer_schema && workorder.answer_schema.fields
                  && workorder.answer_schema.fields.find(item => item.type === 'multi_field')
                  &&(
                  <CustomFieldDetail
                    data={workOrderFields.response}
                    fields={workOrderFields.schema}
                  />
                  )}
                  </>
              </div>
              )}

                {
                  f.type.includes('dataSourceMultiLevel') && (
                    <>
                    {Object.keys(f?.levels).map(i=><div
                      key={f.id}
                      className={styles.infoHalf}
                    >
                      <span>{f?.levels?.[i]?.title||i}</span>
                      <p>{workorder.response?.[f?.id]?.[i]}</p>
                                                   </div>)}
                    </>
                  )
                }
                {((f.type === 'wildlife_species') || (f.type === 'dataSource' && f.dataSourceID === 'ds10'))
              && workorder?.response[f.id] && Object.keys(workorder?.response[f.id] || {})?.length > 0 && (
                <>
                {handleWildlifeSpeciesField(f, workorder?.response)}
                </>
                )}
            </>
          ))}
        </div>

        {workorder.attachments.length >0 && (
          <Modal
            showIn={modal}
            onClose={() => this.setState({ modal: false })}
            contentStyles={{
              overflow: 'visible',
              background: '#E6EAEE',
              padding: '20px 40px'
            }}
          >
            <div>
              {workorder.attachments.length > 1
                ? <PhotoCarousel photos={workorder.attachments} initialSlide={initialSlide} />
                :(
                  <div>
                    <img src={workorder.attachments[0].url} className={styles.workimg} alt="" />
                  </div>
                )
              }
            </div>
          </Modal>
        )}
      </Collapsible>
      </>
    );
  }
}

WorkorderInfo.propTypes = {
  workorder: PropTypes.shape({}).isRequired
};

export default WorkorderInfo;
